<template>
  <div class="detail">
    <div class="content">
      <div class="title">{{ data.extra ? data.extra.name : "" }}</div>
      <video
        class="video-box"
        controls
        :poster="data.extra ? data.extra.video_image : ''"
        :src="data.extra ? data.extra.video_address : ''"
      ></video>
      <div class="auther">作者姓名：{{ data.extra.auther }}</div>
      <div class="desc">简介：{{ data.extra.describe }}</div>
    </div>
  </div>
</template>

<script>
import { wxShare } from "../utils/wxUtils.js";
import { getDetail } from "../service/index.js";
export default {
  name: "detail",
  data() {
    return {
      data: {}
    };
  },
  mounted() {
    this.getVideoDetail();
  },
  methods: {
    async getVideoDetail() {
      const res = await getDetail(this.$route.query.id);
      console.log(res.data.data);
      this.data = res.data.data.vote_option;
      const ua = window.navigator.userAgent.toLowerCase();
      if (/micromessenger/.test(ua)) {
        wxShare(
          true,
          this.data.extra.name,
          "爱上上虞的100个理由短视频征集大赛",
          this.data.extra.name,
          "https://mhudong.cztv.com/265381#/",
          "https://ohudong.cztv.com/hudong/admin/2022/10/24/0b1be65a01286d6ad81d3c3c0abe4f59.jpg"
        );
      }
    }
  }
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  min-height: 1000px;
  background: url("../assets/img/descBg.jpg") top center no-repeat;
  background-size: 100% auto;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;

  .content {
    margin-top: 463px;
    width: 1000px;
    padding: 0px 90px;
    height: auto;
    background-color: #fff8de;
    border-radius: 20px;
    margin-bottom: 80px;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;

    .title {
      margin-top: 30px;
      font-family: SourceHanSansCN-Medium;
      font-size: 30px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #145878;
    }

    video {
      margin-top: 30px;
      width: 800px;
      height: 450px;
    }
    .auther {
      align-self: flex-start;
      margin-top: 30px;
      font-family: SourceHanSansCN-Medium;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      color: rgb(49, 47, 47);
    }
    .desc {
      margin-bottom: 40px;
      align-self: flex-start;
      text-align: left;
      font-family: SourceHanSansCN-Medium;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      color: rgb(49, 47, 47);
    }
  }
}
</style>
